import { render, staticRenderFns } from "./outfit-product-expand.vue?vue&type=template&id=7320ac16&"
import script from "./outfit-product-expand.vue?vue&type=script&lang=ts&"
export * from "./outfit-product-expand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports